var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    enableBackground: "new 0 0 22 22",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main---search",
    transform: "translate(-39.000000, -146.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(39.000000, 146.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M10.8,11.3c-0.6,0.1-1.2-0.1-1.7-0.4C6.4,9.5,3.7,8.1,1,6.7C0.7,6.6,0.5,6.5,0.4,6.3c-0.5-0.4-0.5-0.9,0-1.3 c0.2-0.2,0.4-0.3,0.7-0.4C3.7,3.3,6.4,1.9,9,0.5c1.2-0.6,2.5-0.6,3.7,0c2.6,1.4,5.3,2.7,7.9,4.1c0.2,0.1,0.3,0.2,0.5,0.3 c0.7,0.5,0.7,1.1,0,1.6c-0.2,0.1-0.3,0.2-0.5,0.3c-2.7,1.4-5.3,2.8-8,4.2C12.1,11.2,11.5,11.4,10.8,11.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M10.8,16.6c-0.6,0.1-1.2-0.1-1.8-0.4c-2.8-1.4-5.5-2.9-8.3-4.3c-0.4-0.2-0.8-0.5-0.7-1.1 c0.1-0.4,0.4-0.7,0.8-0.7c0.3-0.1,0.7,0.1,0.9,0.3c2.5,1.3,5.1,2.6,7.6,4c1.1,0.6,2.1,0.6,3.2,0c2.5-1.3,5-2.6,7.6-3.9 c0.2-0.1,0.5-0.3,0.7-0.3c0.4-0.1,0.8,0.1,1,0.5s0.1,0.8-0.2,1.1c-0.2,0.2-0.4,0.3-0.6,0.4c-2.6,1.3-5.1,2.7-7.7,4 C12.6,16.4,11.8,16.7,10.8,16.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-5",
    d: "M11.1,22c-0.7,0.1-1.4-0.2-2.1-0.5c-2.7-1.4-5.3-2.7-8-4.1c-0.2-0.1-0.5-0.3-0.7-0.4 c-0.3-0.3-0.4-0.7-0.2-1.1s0.6-0.6,1-0.4c0.2,0.1,0.4,0.2,0.7,0.3c2.5,1.3,5.1,2.6,7.6,4c1.1,0.6,2,0.6,3.1,0 c2.6-1.4,5.2-2.7,7.8-4.1c0.4-0.2,0.7-0.4,1.1-0.1c0.6,0.3,0.6,1.1,0.1,1.5c-0.2,0.2-0.4,0.3-0.6,0.4c-2.6,1.3-5.2,2.7-7.9,4 C12.5,21.8,11.8,22,11.1,22"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataicon);
export default __webpack_public_path__ + "static/media/data.icon.a4df9c9e.svg";
export { ForwardRef as ReactComponent };